import React, { Component } from 'react'
import Linkedin from './icon_in.svg'
import FaceBook from './icon_fb.svg'
import Wechat from './icon_wechat.svg'
import Mail from './icon_mail.svg'
import Woosik from './woosik.jpg'
import HomeAboutQR from './HomeAboutQR'


export default class HomeAbout extends Component {

    constructor() {
        super()
        this.state = {
            isQR : false
        }
    }

    closeFx = () => {

        this.setState(
            { isQR : false }
        )
    }

    openFx = () => {

        this.setState(
            { isQR : true }
        )
    }

    close2Fx = () => {
                this.props.closeMe()
    }


    render() {

        return (

            <React.Fragment>

                { this.state.isQR ? <HomeAboutQR closeMe={this.closeFx} /> : null }

                <div className='HomeAboutMe'>

                    <i className='material-icons' onClick={this.close2Fx}>close</i>

                    <div id='HomeAboutPic'>
                        <img src={Woosik} alt='woosik' />
                    </div>

                    <div id='HomeAboutTxt'>
                        <span>
                        Thanks for visiting my site!<br />
                        This site was built for my personal purpose. So, there are only few contents for visitors like you.<br />
                        However, If you have something to ask, please visit my SNS.<br /><br />
                        RYU,Woosik
                        </span>
                    </div>

					<div id='HomeAboutSNS'>
                        <a href='https://www.linkedin.com/in/chancehouse/'>
                            <img src={Linkedin} alt='LinkedIn' />
                        </a>

                        <a href='https://www.facebook.com/redcomma'>
                            <img src={FaceBook} alt='FaceBook' />
                        </a>

                        <img src={Wechat} onClick={this.openFx} alt='WeChat' />

                        <a href='mailto:ryuwoosil@gmail.com'>
                            <img src={Mail} alt='email' />
                        </a>
                    </div>

                </div>
                	
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/home/HomeAbout.js